export default {
	heading: "Recommended templates",
};
